import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";

/**
 * Component to render Investor Relations section for eligibility tab
 */
const InvestorRelationsSection = (): React.ReactElement => {
  return (
    <div
      className="bg-gray-150"
      data-testid="investor-relations-section-component"
    >
      <AccordionV2
        testId="investor-relations"
        className="border-l border-r py-4"
        headerChildren={
          <EventsAwardsAccordionHeader title="Best Investor Relations" />
        }
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4">
          <p>
            The following criteria are used to identify the final shortlist of
            companies:
          </p>

          <ul className="list-outside list-disc pl-8">
            <li>Responsiveness of the IR contact to cold calls and emails;</li>

            <li>
              Comprehensiveness/ user-friendliness of the IR link, specifically
              the types and quality of information provided (e.g. annual
              reports, presentations, etc.) and speed of downloads;
            </li>

            <li>
              Whether the company submits requested information on the IR
              function and practices;
            </li>

            <li>
              Whether there are negative news items related to IR, such as being
              on the SGX watchlist, late announcement of financial or AGM
              results, modified audit opinion, and queries about disclosures and
              announcements;
            </li>
          </ul>
        </div>
      </AccordionV2>
    </div>
  );
};

export default InvestorRelationsSection;
